import React, { createRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import * as CardAction from './../../actions/card.actions';
import { ClassNameMap } from '@material-ui/styles';

const styles = {
  root: {
    border: '1px solid #F0EEEC',
    borderRadius: 2,
    boxShadow: '1px 1px 1px 0 #CCCCCC',
    display: 'flex',
    backgroundColor: '#ffffff',
    marginTop: '2px'
  }
};

type Props = {
    classes: ClassNameMap<"root">,
    columnId: string,
    hideAIForm: () => void,
    aiType: number,
};

const AIDescForm = (props: Props) => {
    const { classes, columnId, hideAIForm } = props;
    const inputRef = createRef<HTMLTextAreaElement>();
    const [description, setDescription] = useState<string>("");
    const dispatch = useDispatch();

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
        window.addEventListener("click", saveAI, true);
        return () => { 
            window.removeEventListener("click", saveAI, true); 
        }
    }, []);

    const saveAI = (e: any) => {
        // allow multi-line descriptions (shift + enter)
        const isValidCmd = ((e.keyCode == 13 && e.shiftKey == false) || e.type == "blur");
        const isDescriptionEmpty = (description.trim() === "");

        if (!isDescriptionEmpty && isValidCmd) {
           hideAIForm();
           dispatch(CardAction.addAICard(columnId, { description, type: props.aiType }));
        } else {
            let heighlightedText = window.getSelection().toString();
            if($('.' + classes.root).has(e.target).length === 0 && heighlightedText.length === 0) {
                hideAIForm();
            }
            return false;
        }
    }
    
    return (
        <div  className={classes.root}>
            <textarea
                ref={inputRef}
                name="description"
                className="ai-desc-field"
                value={description}
                onChange={e => setDescription(e.target.value)}
                onBlur={e => saveAI(e)}
                onKeyDown={e => saveAI(e)}
            />
        </div>
    )
}

export default withStyles(styles)(AIDescForm);